import {
  takeLatest,
  takeEvery,
  call,
  put,
  all,
  cancelled,
} from "redux-saga/effects"
import axios from "axios"

import { GET_CONFIGURATION_WATCHER, GET_IMAGE_LOGO_WATCHER } from "./constants"
import {
  getConfigurationSuccess,
  getConfigurationFailed,
  getImageLogoSuccess,
  getImageLogoFailed,
} from "./actions"
import { LOCAL_TOKEN } from "../../../utils/storage"
import { stepMailWatcherApi } from "../Home/saga"

export function getConfigurationApi({ idMeasure, data = {} }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasure}/first/step`,
    data,
  })
}

export function* getConfigurationSaga(action) {
  try {
    const {
      data: { data },
    } = yield call(stepMailWatcherApi, action.payload)

    yield put(getConfigurationSuccess(data))
  } catch (error) {
    yield put(getConfigurationFailed())

    returnMessage(error)
  }
}

// GET IMAGE OR LOGO
export function getImageLogoApi({ idMeasure, fd, type }) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${idMeasure}/upload/${type}/email`,
    data: fd,
  })
}

export function* getImageLogoSaga(action) {
  try {
    const { data } = yield call(getImageLogoApi, action.payload)

    yield put(getImageLogoSuccess({ ...data, type: action.payload.type }))
  } catch (error) {
    yield put(getImageLogoFailed({ type: action.payload.type }))
    const {
      data: {
        errors: { uploaded_file },
      },
    } = error.response
    message.error(uploaded_file[0], 5)
  }
}

// Individual exports for testing
export default function* mailConfigurationSaga() {
  yield takeLatest(GET_CONFIGURATION_WATCHER, getConfigurationSaga)
  yield takeEvery(GET_IMAGE_LOGO_WATCHER, getImageLogoSaga)
}
